<template>
  <div id="marketing-home">
    <v-card flat>
      <v-img
        :src="titleImg"
        max-height="200"
        aspect-ratio=1.5
        position="center right"
        gradient="to right, rgba(0,0,0,.44), rgba(0,0,0,.44)"
      />
    </v-card>
    
    <v-container>
      <v-layout>
        <v-flex>
            <macna-survey/>
        </v-flex>
      </v-layout>
    </v-container>


  </div>
</template>

<script>
import MacnaSurveys from './charts/MACNAsurveys'

export default {
  data () {
    return {
      titleImg: 'https://images.unsplash.com/photo-1511370727486-ef2f0c456710?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=cdd9c5f3f18198c02f019dde0207385e&auto=format&fit=crop&w=1350&q=80'
    }
  },
  components: {'macna-survey': MacnaSurveys}
}
</script>



// WEBPACK FOOTER //
// src/layouts/marketing/Marketing.vue